import React, { useEffect, useState } from 'react'
import './AdminLiveScoreTicker.css'

const AdminLiveScoreTicker = () => {
	const [enabled, setEnabled] = useState(false)
	const [loading, setLoading] = useState(true)
	const [saving, setSaving] = useState(false)
	const [error, setError] = useState('')

	useEffect(() => {
		const controller = new AbortController()

		const loadSettings = async () => {
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/admin/liveScoreTicker/settings`,
					{ signal: controller.signal },
				)

				if (!response.ok) {
					throw new Error('Could not load ticker settings')
				}

				const data = await response.json()

				setEnabled(data.liveScoreTickerEnabled === true)
			} catch (err) {
				if (err.name !== 'AbortError') {
					setError(err.message)
				}
			} finally {
				if (!controller.signal.aborted) {
					setLoading(false)
				}
			}
		}

		loadSettings()

		return () => controller.abort()
	}, [])

	const toggleTicker = async () => {
		if (saving || loading) return

		const newValue = !enabled

		setSaving(true)
		setError('')

		try {
			const response = await fetch(
				`${process.env.REACT_APP_BACKEND_URL}/admin/liveScoreTicker/settings`,
				{
					method: 'PATCH',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						liveScoreTickerEnabled: newValue,
					}),
				},
			)

			const data = await response.json()

			if (!response.ok) {
				throw new Error(data.message || 'Could not update ticker')
			}

			setEnabled(data.liveScoreTickerEnabled === true)
		} catch (err) {
			setError(err.message)
		} finally {
			setSaving(false)
		}
	}

	return (
		<div className='adminTicker'>
			<div className='adminTicker__info'>
				<h2>Live Score Ticker</h2>

				<p>
					Show or hide the scrolling live scores on the tournament schedule
					page.
				</p>

				{loading ? (
					<span className='adminTicker__status'>
						Loading ticker settings...
					</span>
				) : (
					<span
						className={`adminTicker__status ${
							enabled ? 'adminTicker__status--on' : 'adminTicker__status--off'
						}`}
					>
						{enabled ? 'Ticker is ON' : 'Ticker is OFF'}
					</span>
				)}

				{error && <p className='adminTicker__error'>{error}</p>}
			</div>

			<button
				type='button'
				className={`adminTicker__toggle ${
					enabled ? 'adminTicker__toggle--on' : ''
				}`}
				role='switch'
				aria-checked={enabled}
				aria-label='Enable live score ticker'
				onClick={toggleTicker}
				disabled={loading || saving || !!error}
			>
				<span className='adminTicker__knob' />
			</button>

			{saving && <span className='adminTicker__saving'>Saving...</span>}
		</div>
	)
}

export default AdminLiveScoreTicker
